export default {
  hasUnreadNotification(state) {
    return Boolean(state.notification) && !state.notification.read_at;
  },
};
